// lib/dashboardCache.ts
// localStorage-based cache for dashboard API responses with 5-minute TTL

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
const CACHE_PREFIX = "dc_";

interface CacheEntry {
  data: unknown;
  ts: number;
}

function getUserNs(): string {
  try {
    return (localStorage.getItem("userId") || "anon").slice(0, 12);
  } catch {
    return "anon";
  }
}

export function makeCacheKey(
  type: string,
  params: Record<string, unknown>
): string {
  try {
    return `${CACHE_PREFIX}${getUserNs()}_${type}_${JSON.stringify(params)}`;
  } catch {
    return `${CACHE_PREFIX}${type}`;
  }
}

export function getCache<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const entry: CacheEntry = JSON.parse(raw);
    if (Date.now() - entry.ts > CACHE_TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return entry.data as T;
  } catch {
    return null;
  }
}

export function setCache(key: string, data: unknown): void {
  try {
    const entry: CacheEntry = { data, ts: Date.now() };
    localStorage.setItem(key, JSON.stringify(entry));
  } catch {
    // localStorage full or unavailable — silently skip caching
  }
}

export function clearDashboardCache(): void {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(CACHE_PREFIX))
      .forEach((k) => localStorage.removeItem(k));
  } catch {
    // ignore
  }
}
